import { stringify } from 'telejson';

import { RequestConfig } from '../types';
import { hashValue } from './hashValue';

/**
 * Identifies a request for in-flight cancellation and for the id of the error
 * toast it may raise.
 *
 * The method and url stay readable to keep the key debuggable; the body and
 * params are hashed because they carry applicant data (names, dates of birth,
 * income, identity details) and the key ends up in a toast id, and from there
 * in the DOM. Hashing them separately keeps a change of body distinguishable
 * from a change of params.
 */
export const constructIdempotencyKey = ({
  method = 'GET',
  url,
  data,
  params,
}: RequestConfig): string =>
  `${method}|${url}|${hashValue(String(stringify(data)))}|${hashValue(String(stringify(params)))}`;
